import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PUBLIC_ROUTES } from '../constants/app.constants';
import { UserRole } from '../constants/roles.enum';

/**
 * Blocks read-only receptionists from a route, redirecting them to the calendar. Used for pages a
 * receptionist must not access (e.g. profile). Kept separate from PrivateWithRoleGuard, which is
 * shared with routes receptionists are allowed to use (calendar, settings, messages, notifications).
 */
export const ReceptionistBlockedGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isUserLoggedIn()) {
    return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
  }

  if (auth.getDecodedToken().role === UserRole.RECEPTIONIST) {
    return router.createUrlTree([auth.homeRoute()]);
  }

  return true;
};
